const _temp0 = require("./works/Agate/marker.ts");
const _temp1 = require("./works/Djadochta/marker.ts");
const _temp2 = require("./works/Elliot/marker.ts");
const _temp3 = require("./works/Gargano/marker.ts");
const _temp4 = require("./works/Gogo/marker.ts");
const _temp5 = require("./works/Hammerschmiede/marker.ts");
const _temp6 = require("./works/Hornerstown/marker.ts");
const _temp7 = require("./works/Irdin/marker.ts");
const _temp8 = require("./works/Ischigualasto/marker.ts");
const _temp9 = require("./works/Jialingjiang/marker.ts");
const _temp10 = require("./works/Joggins/marker.ts");
const _temp11 = require("./works/Judith/marker.ts");
const _temp12 = require("./works/Kuanti/marker.ts");
const _temp13 = require("./works/Mammoth/marker.ts");
const _temp14 = require("./works/Monte/marker.ts");
const _temp15 = require("./works/Moth/marker.ts");
const _temp16 = require("./works/Ocher/marker.ts");
const _temp17 = require("./works/Patrick/marker.ts");
const _temp18 = require("./works/Rhynie/marker.ts");
const _temp19 = require("./works/Seaham/marker.ts");
const _temp20 = require("./works/Sirius/marker.ts");
const _temp21 = require("./works/Solnhofen/marker.ts");
const _temp22 = require("./works/Talara/marker.ts");
const _temp23 = require("./works/Wadi_al_Hitan/marker.ts");
const _temp24 = require("./works/archer/marker.ts");
const _temp25 = require("./works/bahariya/marker.ts");
const _temp26 = require("./works/ballagan/marker.ts");
const _temp27 = require("./works/bathans/marker.ts");
const _temp28 = require("./works/besano/marker.ts");
const _temp29 = require("./works/brea/marker.ts");
const _temp30 = require("./works/bromacker/marker.ts");
const _temp31 = require("./works/bugti/marker.ts");
const _temp32 = require("./works/burgess/marker.ts");
const _temp33 = require("./works/cabrieres/marker.ts");
const _temp34 = require("./works/candeleros/marker.ts");
const _temp35 = require("./works/chanares/marker.ts");
const _temp36 = require("./works/chemnitz/marker.ts");
const _temp37 = require("./works/cleveland/marker.ts");
const _temp38 = require("./works/consthum/marker.ts");
const _temp39 = require("./works/crato/marker.ts");
const _temp40 = require("./works/denver/marker.ts");
const _temp41 = require("./works/dino_park/marker.ts");
const _temp42 = require("./works/ein_yabrud/marker.ts");
const _temp43 = require("./works/elmo/marker.ts");
const _temp44 = require("./works/emu/marker.ts");
const _temp45 = require("./works/ermaying/marker.ts");
const _temp46 = require("./works/escuminac/marker.ts");
const _temp47 = require("./works/fezouata/marker.ts");
const _temp48 = require("./works/flores/marker.ts");
const _temp49 = require("./works/fora/marker.ts");
const _temp50 = require("./works/gigantopithecus/marker.ts");
const _temp51 = require("./works/green-river/marker.ts");
const _temp52 = require("./works/guimarota/marker.ts");
const _temp53 = require("./works/gulch/marker.ts");
const _temp54 = require("./works/hanson/marker.ts");
const _temp55 = require("./works/hell-creek/marker.ts");
const _temp56 = require("./works/holocene_nz/marker.ts");
const _temp57 = require("./works/hunsrück/marker.ts");
const _temp58 = require("./works/jebel/marker.ts");
const _temp59 = require("./works/kimmeridge/marker.ts");
const _temp60 = require("./works/kuldana/marker.ts");
const _temp61 = require("./works/las_hoyas/marker.ts");
const _temp62 = require("./works/madagascar/marker.ts");
const _temp63 = require("./works/madygen/marker.ts");
const _temp64 = require("./works/maevarano/marker.ts");
const _temp65 = require("./works/mazon/marker.ts");
const _temp66 = require("./works/morrison/marker.ts");
const _temp67 = require("./works/naracoorte/marker.ts");
const _temp68 = require("./works/ngorora/marker.ts");
const _temp69 = require("./works/niobrara/marker.ts");
const _temp70 = require("./works/paja/marker.ts");
const _temp71 = require("./works/paratethys/marker.ts");
const _temp72 = require("./works/pebas/marker.ts");
const _temp73 = require("./works/pierre/marker.ts");
const _temp74 = require("./works/pisco/marker.ts");
const _temp75 = require("./works/pleistocene/marker.ts");
const _temp76 = require("./works/pueblo/marker.ts");
const _temp77 = require("./works/remigiusberg/marker.ts");
const _temp78 = require("./works/rio-do-rasto/marker.ts");
const _temp79 = require("./works/riversleigh/marker.ts");
const _temp80 = require("./works/sannine/marker.ts");
const _temp81 = require("./works/shanwang/marker.ts");
const _temp82 = require("./works/sicily/marker.ts");
const _temp83 = require("./works/soom/marker.ts");
const _temp84 = require("./works/sulphur/marker.ts");
const _temp85 = require("./works/tapinocephalus/marker.ts");
const _temp86 = require("./works/tiki/marker.ts");
const _temp87 = require("./works/toolebuc/marker.ts");
const _temp88 = require("./works/winton/marker.ts");
const _temp89 = require("./works/whitewater/marker.ts");
const _temp90 = require("./works/yixian/marker.ts");
const _temp91 = require("./works/zechstein/marker.ts");
module.exports = {
  "Agate": _temp0,
  "Djadochta": _temp1,
  "Elliot": _temp2,
  "Gargano": _temp3,
  "Gogo": _temp4,
  "Hammerschmiede": _temp5,
  "Hornerstown": _temp6,
  "Irdin": _temp7,
  "Ischigualasto": _temp8,
  "Jialingjiang": _temp9,
  "Joggins": _temp10,
  "Judith": _temp11,
  "Kuanti": _temp12,
  "Mammoth": _temp13,
  "Monte": _temp14,
  "Moth": _temp15,
  "Ocher": _temp16,
  "Patrick": _temp17,
  "Rhynie": _temp18,
  "Seaham": _temp19,
  "Sirius": _temp20,
  "Solnhofen": _temp21,
  "Talara": _temp22,
  "Wadi_al_Hitan": _temp23,
  "archer": _temp24,
  "bahariya": _temp25,
  "ballagan": _temp26,
  "bathans": _temp27,
  "besano": _temp28,
  "brea": _temp29,
  "bromacker": _temp30,
  "bugti": _temp31,
  "burgess": _temp32,
  "cabrieres": _temp33,
  "candeleros": _temp34,
  "chanares": _temp35,
  "chemnitz": _temp36,
  "cleveland": _temp37,
  "consthum": _temp38,
  "crato": _temp39,
  "denver": _temp40,
  "dino_park": _temp41,
  "ein_yabrud": _temp42,
  "elmo": _temp43,
  "emu": _temp44,
  "ermaying": _temp45,
  "escuminac": _temp46,
  "fezouata": _temp47,
  "flores": _temp48,
  "fora": _temp49,
  "gigantopithecus": _temp50,
  "green-river": _temp51,
  "guimarota": _temp52,
  "gulch": _temp53,
  "hanson": _temp54,
  "hell-creek": _temp55,
  "holocene_nz": _temp56,
  "hunsrück": _temp57,
  "jebel": _temp58,
  "kimmeridge": _temp59,
  "kuldana": _temp60,
  "las_hoyas": _temp61,
  "madagascar": _temp62,
  "madygen": _temp63,
  "maevarano": _temp64,
  "mazon": _temp65,
  "morrison": _temp66,
  "naracoorte": _temp67,
  "ngorora": _temp68,
  "niobrara": _temp69,
  "paja": _temp70,
  "paratethys": _temp71,
  "pebas": _temp72,
  "pierre": _temp73,
  "pisco": _temp74,
  "pleistocene": _temp75,
  "pueblo": _temp76,
  "remigiusberg": _temp77,
  "rio-do-rasto": _temp78,
  "riversleigh": _temp79,
  "sannine": _temp80,
  "shanwang": _temp81,
  "sicily": _temp82,
  "soom": _temp83,
  "sulphur": _temp84,
  "tapinocephalus": _temp85,
  "tiki": _temp86,
  "toolebuc": _temp87,
  "winton": _temp88,
  "whitewater": _temp89,
  "yixian": _temp90,
  "zechstein": _temp91
}